import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import Button from '../../Button'
import { Divider as DividerComponent } from '../../Divider'
import { Headline2 } from '../../Headline2'
import Text from '../../Text'
import { EpostValidationErrorsTable } from '../EpostValidationErrorsTable'

import * as styles from './EpostValidationErrors.module.css'

import EditIcon from '../../../icons/edit.svg'

function EpostValidationErrors({
  ButtonEdit = Button.Outlined,
  Divider = DividerComponent,
  Table = EpostValidationErrorsTable,
  buttonEditProps: {
    beforeIconProps: { Icon = EditIcon, ...beforeIconProps } = EMPTY_OBJECT,
    text: buttonEditText = 'Epost.ValidationErrorsEditBtnKey',
    ...buttonEditProps
  } = EMPTY_OBJECT,
  className = styles.EpostValidationErrors,
  tableProps,
  text,
  title,
}) {
  const { t } = useTranslation()

  return (
    <>
      <Divider className={styles.divider} />
      <div className={className}>
        <div className={styles.headerWrapper}>
          <Headline2>{title || t('Epost.ValidationErrorsTitleKey')}</Headline2>

          <ButtonEdit
            {...buttonEditProps}
            beforeIconProps={{ ...beforeIconProps, Icon }}
            text={t(buttonEditText)}
          />
        </div>

        <Text>{text}</Text>

        <Table {...tableProps} />
      </div>
    </>
  )
}

export default EpostValidationErrors
